import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import './style.css'
import { RxCross2 } from "react-icons/rx";
import { useSelector } from 'react-redux';
import { getPrivilegedCodeAndSymbol } from '../../api/otherEndPoints/necessoryEndPoints';
import { getModelWiseParams } from '../../services/util/backdatedParams';
import Accordion from 'react-bootstrap/Accordion';
import { accessChecking } from '../../services/util/util';

interface returnSidebarProps {
    setVisibleSidebar: any,
    visibleSidebar: any,
}
interface SidebarDataItem {
    [key: string]: any;
}
const ReturnSidebar: React.FC<returnSidebarProps> = ({ setVisibleSidebar, visibleSidebar }: any) => {

    const [rwCost, setRwCost] = useState<any>(true);
    const [privilegedCodeAndSymbol, setPrivilegedCodeAndSymbol] = useState<any>([]);
    const rightSidebarSelectorData: SidebarDataItem[] = useSelector((state: any) => {
        // console.log("value",state?.rightSidebarData?.sidebarReturnData && Object.keys(state?.rightSidebarData?.sidebarReturnDataghtSidebarSelectorData[0])[0])
        return state?.rightSidebarData?.sidebarReturnData;
    })
    const successRatioDataSelector: any = useSelector((state: any) => {
        return state?.rightSidebarData?.successRatioData
    })
    const tradeDuration: any = useSelector((state: any) => {
        return state?.rightSidebarData?.tradeDuration
    })
    const selectedDate: any = useSelector((state: any) => {
        return state?.todayReturnCalculator?.selectedDate
    })
    const theme: any = useSelector((state: any) => {
        return state.theme.isTheme;
      })

    const background_Color = () => {
        return "black";
    }

    const test_color = () => {
        return "white";
    }

    const displayColor = () => {
        return "gray";
    }

    const handleReturnSidebarClose = () => {
        setVisibleSidebar(false);
    }

    useEffect(() => {
        try{
            (async function fetchCodeAndSymbol(){
                let codeAndSymbol:any = await getPrivilegedCodeAndSymbol();
                if(!codeAndSymbol.error) setPrivilegedCodeAndSymbol(codeAndSymbol?.data);
                else setPrivilegedCodeAndSymbol([]);
            })();
            
        }catch(e){
            console.log("Error when try to get privilege code and symbol",e);
        }

        if (visibleSidebar) {
            setTimeout(() => {
                const rows = Array.from(document.querySelectorAll('.trr'));
                function slideOut(row: any) {
                    row.classList.add('slide-out');
                }
                function slideIn(row: any, index: any) {
                    setTimeout(function () {
                        row.classList.add('slide-in');
                    }, (index + 5) * 30);
                }
                rows.forEach(slideOut);
                rows.forEach(slideIn);
            }, 1)
        }
        else {
            const rows = Array.from(document.querySelectorAll('.trr'));
            function slideOut(row: any) {
                row.classList.remove('slide-out');
            }
            function slideIn(row: any, index: any) {
                setTimeout(function () {
                    row.classList.remove('slide-in');
                }, (index + 5) * 30);
            }
            rows.forEach(slideOut);
            rows.forEach(slideIn);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visibleSidebar])

    const getFontColorAsPerValue = (value: any) => {
        if (theme === 'light') {
            return value >= 0 ? '#338f33' : "red";
        }
        else if(theme==='dark'){
            return value >= 0 ? "lightgreen" : "orangered";
        }
        else if(theme==='b&w'){
            return value >= 0 ? 'lightgreen' : "orangered";
        }
    }


    const ref = useRef<any>(null);
    const handleClickOutside = (event: MouseEvent) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setVisibleSidebar(false)
        }
    };
    document.addEventListener('click', handleClickOutside, true);

    const getBgThemeColor = () =>{
        if(theme==='light'){
            return "rgb(209 225 239)";
        }
        else if(theme==='dark'){
            return "rgb(73 62 80)";
        }
        else if(theme==='b&w'){
            return "#cfcfcf6e";
        }
    }

    const getFontThemeColor = () =>{
        if(theme==='light'){
            return "black";
        }
        else{
            return "white";
        }
    }

    
    return (
        <div>

            <div ref={ref} className={`rightBarDiv ${visibleSidebar ? 'show_rightBarDiv' : ''}`}>
                <div className='closeRightBarContainer' onClick={handleReturnSidebarClose}><span><RxCross2 /></span></div>
                {rightSidebarSelectorData?.length === 0 ?
                    <div style={{ width: "100%", height: "40%", minHeight: "14rem", position: "relative", backgroundColor: getBgThemeColor(), borderRadius: "0.5rem" }}>

                        <div className='noTradeImgDiv'>
                            <img src="/images/noTradeImg.png" alt="No trade image" style={{ width: "34vh", minWidth: "11rem" }} />

                            <h5 style={{ marginTop: "1rem", fontSize: "1rem", color: `${test_color()}`, width: "100%", fontWeight: 400, fontFamily: 'Abril Fatface', textAlign: "center" }}>
                                <span className="text_1" style={{ color: getFontThemeColor() }}>Waiting for trades...</span>
                                <span className="text_2" style={{ color: getFontThemeColor() }}>Waiting for trades...</span>
                            </h5>
                        </div>

                    </div>
                    :
                    <>
                        <div className='date_cost_header'>

                            <span className='bodyfont date_header' style={{ color: "white" }}>{moment(selectedDate).format("MMM Do, YYYY") === moment(new Date()).format("MMM Do, YYYY") ? `${moment(selectedDate).format("DD MMM YYYY")} (Today)` : moment(selectedDate).format("DD MMM YYYY")}</span>
                            <div className='cost_header'>
                                {/* (moment(selectedDate).format('YYYY-MM-DD')) > minChargeDate */}
                                {true ?
                                    <p className='bodyfont' >
                                        <input type='checkbox' checked={rwCost} style={{ cursor: 'pointer', height: '50%', width: '1.7rem' }} onChange={() => setRwCost(!rwCost)} />
                                        Inclusive of cost</p> : ""}
                            </div>


                        </div>
                        <div className='pieChart' style={{ backgroundColor: `${background_Color()}` }}>
                            <div className='pieChart_successAndTotal' >
                                <p className='bodyfont' style={{ color: `${test_color()}` }}>Success ratio : {(successRatioDataSelector?.success_ratio) !== null ? (successRatioDataSelector?.success_ratio)?.toFixed(2) : ''}%</p>
                                <p className='bodyfont' style={{ color: `${test_color()}` }}>Total calls : {successRatioDataSelector?.total_calls}</p>
                            </div>

                            <div className='bodyfont pieChart_positiveAndNegative'>
                                <div >
                                    <p className='green_dot'></p>
                                    <p style={{ color: `${test_color()}` }} >Positive calls : {successRatioDataSelector?.positive_pl}</p>
                                </div>
                                <div >
                                    <a className='red_dot'></a>
                                    <p style={{ color: `${test_color()}` }}>Negative calls : {successRatioDataSelector?.negative_pl}</p>
                                </div>
                            </div>
                        </div>
                        <div className='overviewDiv'>

                            <div className='modelWiseReturn' style={{ backgroundColor: `${background_Color()}`, color: `${test_color()}`, position: "relative" }}>
                                <span>
                                    <p className='bodyfont'>Model returns</p>
                                </span>
                                <div className='modelWiseReturnTable ' style={{ color: `${test_color()}` }}>
                                {rightSidebarSelectorData?.length > 0 && <Accordion defaultActiveKey="1">
                                        <Accordion.Item eventKey="1" className='trr'>
                                            <Accordion.Header className='subtitles' style={{padding:"0 2rem"}}>
                                                <label className='form_label'>
                                                    OPT S
                                                </label>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                {rightSidebarSelectorData.map((item: any, idx: any)=>{
                                                    const key:any = Object.keys(item)[0];
                                                    const { count, returnPer, returnAfter } = item[key];
                                                    return(<>
                                                        {(['AIONIFABI','QIONIFSMI','QIONIFSRI','AIONIFMMI','AIOBANABI'].includes((key.split('-')[0]).slice(0,-1)))&&
                                                        <div>
                                                            <label className='form-value tableElem' htmlFor={item.header}>{getModelWiseParams(key.includes('-')? key.split('-')[0].slice(0,-1)+'-'+key.split('-')[1]:key.slice(0,-1))} ({count})
                                                                {rwCost?<span className="bodyfont hoverReturnSidebar hoverVal" style={{ color: getFontColorAsPerValue(returnAfter), marginRight: "-0rem" }} data-hover={returnAfter !== null ? returnAfter?.toFixed(4) + '%' : ''}>{returnAfter !== null ? returnAfter?.toFixed(2) + '%' : ''}</span>
                                                                :<span className="bodyfont hoverReturnSidebar hoverVal" style={{ color: getFontColorAsPerValue(returnPer), marginRight: "-0rem" }} data-hover={returnAfter !== null ? returnPer?.toFixed(4) + '%' : ''}>{returnPer !== null ? returnPer?.toFixed(2) + '%' : ''}</span>}
                                                            </label>
                                                        </div>
                                                        }
                                                    </>)
                                                })}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2" className='trr'>
                                            <Accordion.Header className='subtitles' style={{padding:"0 2rem"}}>
                                                <label className='form_label' >
                                                    OPT S LFT 
                                                </label>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                {rightSidebarSelectorData.map((item: any, idx: any)=>{
                                                    const key:any = Object.keys(item)[0];
                                                    const { count, returnPer, returnAfter } = item[key];
                                                    return(<>
                                                        {(['AIONIFDDI','AIOBANDDI'].includes(key.slice(0,-1)))&&<div>
                                                            <label className='form-value tableElem' htmlFor={item.header}>{getModelWiseParams(key.slice(0,-1))} ({count})
                                                            {rwCost?<span className="bodyfont hoverReturnSidebar hoverVal" style={{ color: getFontColorAsPerValue(returnAfter), marginRight: "-0rem" }} data-hover={returnAfter !== null ? returnAfter?.toFixed(4) + '%' : ''}>{returnAfter !== null ? returnAfter?.toFixed(2) + '%' : ''}</span>
                                                                :<span className="bodyfont hoverReturnSidebar hoverVal" style={{ color: getFontColorAsPerValue(returnPer), marginRight: "-0rem" }} data-hover={returnAfter !== null ? returnPer?.toFixed(4) + '%' : ''}>{returnPer !== null ? returnPer?.toFixed(2) + '%' : ''}</span>}
                                                            </label>
                                                        </div>}
                                                    </>)
                                                })}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="3" className='trr'>
                                            <Accordion.Header className='subtitles' style={{padding:"0 2rem"}}>
                                            <label className='form_label' >
                                                OPT L 
                                            </label>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                {rightSidebarSelectorData.map((item: any, idx: any)=>{
                                                    const key:any = Object.keys(item)[0];
                                                    const { count, returnPer, returnAfter } = item[key];
                                                    return(<>
                                                        {(key.slice(0,-1)=='AIONIFKKI')&&<div>
                                                            <label className='form-value tableElem' htmlFor={item.header}>{getModelWiseParams(key.slice(0,-1))} ({count})
                                                            {rwCost?<span className="bodyfont hoverReturnSidebar hoverVal" style={{ color: getFontColorAsPerValue(returnAfter), marginRight: "-0rem" }} data-hover={returnAfter !== null ? returnAfter?.toFixed(4) + '%' : ''}>{returnAfter !== null ? returnAfter?.toFixed(2) + '%' : ''}</span>
                                                                :<span className="bodyfont hoverReturnSidebar hoverVal" style={{ color: getFontColorAsPerValue(returnPer), marginRight: "-0rem" }} data-hover={returnAfter !== null ? returnPer?.toFixed(4) + '%' : ''}>{returnPer !== null ? returnPer?.toFixed(2) + '%' : ''}</span>}
                                                            </label>
                                                        </div>}
                                                    </>)
                                                })}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="4" className='trr'>
                                            <Accordion.Header className='subtitles' style={{padding:"0 2rem"}}>
                                                <label className='form_label' >
                                                    EQ N50  
                                                </label>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                {rightSidebarSelectorData.map((item: any, idx: any)=>{
                                                    const key:any = Object.keys(item)[0];
                                                    const { count, returnPer, returnAfter } = item[key];
                                                    return(<>
                                                        {(key.slice(1,3)=='ES'&&privilegedCodeAndSymbol[key.slice(0,-1)])&&<div>
                                                            <label className='form-value tableElem' htmlFor={item.header}>{privilegedCodeAndSymbol[key.slice(0,-1)]}
                                                            {rwCost?<span className="bodyfont hoverReturnSidebar hoverVal" style={{ color: getFontColorAsPerValue(returnAfter), marginRight: "-0rem" }} data-hover={returnAfter !== null ? returnAfter?.toFixed(4) + '%' : ''}>{returnAfter !== null ? returnAfter?.toFixed(2) + '%' : ''}</span>
                                                                :<span className="bodyfont hoverReturnSidebar hoverVal" style={{ color: getFontColorAsPerValue(returnPer), marginRight: "-0rem" }} data-hover={returnAfter !== null ? returnPer?.toFixed(4) + '%' : ''}>{returnPer !== null ? returnPer?.toFixed(2) + '%' : ''}</span>}
                                                            </label>
                                                        </div>}
                                                    </>)
                                                })}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="5" className='trr'>
                                            <Accordion.Header className='subtitles' style={{padding:"0 2rem"}}>
                                                <label className='form_label' >
                                                    EQ N50NXT 
                                                </label>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                {rightSidebarSelectorData.map((item: any, idx: any)=>{
                                                    const key:any = Object.keys(item)[0];
                                                    const { count, returnPer, returnAfter } = item[key];
                                                    return(<>
                                                        {key.slice(0,3)=='QEB'&&<div>
                                                            <label className='form-value tableElem' htmlFor={item.header}>{key.slice(3,key.length-1)}
                                                            {rwCost?<span className="bodyfont hoverReturnSidebar hoverVal" style={{ color: getFontColorAsPerValue(returnAfter), marginRight: "-0rem" }} data-hover={returnAfter !== null ? returnAfter?.toFixed(4) + '%' : ''}>{returnAfter !== null ? returnAfter?.toFixed(2) + '%' : ''}</span>
                                                                :<span className="bodyfont hoverReturnSidebar hoverVal" style={{ color: getFontColorAsPerValue(returnPer), marginRight: "-0rem" }} data-hover={returnAfter !== null ? returnPer?.toFixed(4) + '%' : ''}>{returnPer !== null ? returnPer?.toFixed(2) + '%' : ''}</span>}
                                                            </label>
                                                        </div>}
                                                    </>)
                                                })}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>}
                                </div>

                            </div>

                            <div className='highestReturn hovertext' data-hover="According to trade's highest return" style={{ backgroundColor: `${background_Color()}`, color: `${test_color()}` }}>
                                <div >
                                    <span className=" bodyfont" >Highest return</span>
                                </div>
                                <div className='elems slide-left' style={{ backgroundColor: `${displayColor()}` }}>
                                    {rightSidebarSelectorData && rwCost ?
                                        <p className='bodyfont' >
                                            <span className='bodyfont hoverReturnSidebar hoverReturnVal' style={{ color: getFontColorAsPerValue(rightSidebarSelectorData?.length > 1 && (Object.values(rightSidebarSelectorData[0])[0].returnAfter)) }}
                                                data-hover={(Object.values(rightSidebarSelectorData[0])[0].returnAfter) !== null ? (Object.values(rightSidebarSelectorData[0])[0].returnAfter)?.toFixed(4) : ''}>
                                                {rightSidebarSelectorData?.length > 1
                                                    ? (Object.values(rightSidebarSelectorData[0])[0].returnAfter)?.toFixed(2) + "%"
                                                    : ''}
                                            </span> <small>
                                                {rightSidebarSelectorData?.length > 1
                                                    ? `(${Object.keys(rightSidebarSelectorData[0])[0].slice(0,3)==='QEB' ?
                                                            Object.keys(rightSidebarSelectorData[0])[0].slice(3,-1) :
                                                                privilegedCodeAndSymbol[Object.keys(rightSidebarSelectorData[0])[0].slice(0,-1)] ?
                                                                    privilegedCodeAndSymbol[Object.keys(rightSidebarSelectorData[0])[0].slice(0,-1)] :  
                                                                      getModelWiseParams(accessChecking({'s_code':Object.keys(rightSidebarSelectorData[0])[0]}))})`
                                                    : ''}
                                            </small></p> :

                                        <p className='bodyfont' ><span className='bodyfont hoverReturnSidebar hoverReturnVal' style={{ color: getFontColorAsPerValue(rightSidebarSelectorData?.length > 1 && (Object.values(rightSidebarSelectorData[0])[0].returnAfter > 0)) }}
                                            data-hover={(Object.values(rightSidebarSelectorData[0])[0].returnPer) !== null ? (Object.values(rightSidebarSelectorData[0])[0].returnPer)?.toFixed(4) : ''}
                                        >{rightSidebarSelectorData?.length > 1 ? (Object.values(rightSidebarSelectorData[0])[0].returnPer?.toFixed(2)) + "%" : ''}</span> <small>{rightSidebarSelectorData?.length > 1 ? `(${Object.keys(rightSidebarSelectorData[0])[0].slice(0,3)==='QEB'?Object.keys(rightSidebarSelectorData[0])[0].slice(3,-1):privilegedCodeAndSymbol[Object.keys(rightSidebarSelectorData[0])[0].slice(0,-1)]?privilegedCodeAndSymbol[Object.keys(rightSidebarSelectorData[0])[0].slice(0,-1)]:getModelWiseParams(Object.keys(rightSidebarSelectorData[0])[0].slice(0,-1))})` : ''}</small></p>
                                    }
                                </div>
                            </div>
                            <div className='highestReturn' style={{ backgroundColor: `${background_Color()}`, color: `${test_color()}` }}>
                                <div >
                                    <span className='bodyfont'> No of TSL hits </span>
                                </div>
                                <div className='elems slide-left' style={{ backgroundColor: `${displayColor()}` }}>
                                    <p className='bodyfont' ><small>{successRatioDataSelector?.tsl_hits}</small></p>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>


        </div>

    )
}

export default ReturnSidebar
